import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { LoadingComponent } from "Components/LoadingComponent";
import {
  GET_ADMIN_ATTRIBUTE_DETAILS_URL,
  UPDATE_ATTRIBUTE_ACTION_URL,
  UPDATE_ATTRIBUTE_FIELD_URL,
} from "Constant/api";
import { authService } from "Service/Axios";
import { convertLinkObjectListToJoin } from "Utils";
import {
  COLOR_SETTINGS,
  DESIGN_TYPE_LIST,
  FEILD_TYPE_LIST,
} from "Constant/constants";

export const AttributeDetails = () => {
  const { t } = useTranslation();
  const { id: attributeId } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [attributeDetails, setAttributeDetails] = useState(null);

  const fetchAttributeDetails = async (isUpdate) => {
    if (attributeId) {
      if (!isUpdate) {
        setLoading(true);
      }
      try {
        const payload = { gid: attributeId };
        const response = await authService(
          GET_ADMIN_ATTRIBUTE_DETAILS_URL,
          "POST",
          payload
        );
        setAttributeDetails(response);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error(
          t("common.messages.notification.failed.somethingWentWrong")
        );
      }
    } else {
      setAttributeDetails(null);
    }
  };

  useEffect(() => {
    fetchAttributeDetails();
  }, []);

  // Handle
  const onSaveAction = async (action, actionAccess) => {
    try {
      const payload = {
        gid: action.gid,
        attributeId,
        show: actionAccess,
      };
      const response = await authService(
        UPDATE_ATTRIBUTE_ACTION_URL,
        "POST",
        payload
      );
      if (response.success) {
        toast.success(t("common.messages.notification.success.updateAction"));
      } else {
        toast.error(response.message);
      }
      fetchAttributeDetails(true);
    } catch (error) {
      if (error.response && error.response.data) {
        toast.error(error.response.data.message);
      }
    }
  };

  const onSaveField = async (field, fieldEdit, fieldShow) => {
    try {
      const payload = {
        attributeId,
        gid: field.questionId,
        label: field.label,
        name: field.questionName,
        show: fieldShow,
        edit: fieldEdit,
      };
      const response = await authService(
        UPDATE_ATTRIBUTE_FIELD_URL,
        "POST",
        payload
      );
      if (response.success) {
        toast.success(t("common.messages.notification.success.updateField"));
      } else {
        toast.error(response.message);
      }
      fetchAttributeDetails(true);
    } catch (error) {
      if (error.response && error.response.data) {
        toast.error(error.response.data.message);
      }
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <>
      <LoadingComponent isLoading={loading}>
        <main className="main">
          <div className="card-white card-shadow">
            <div className="page-title-box d-md-flex justify-content-between align-items-center">
              <button
                onClick={handleBack}
                className="btn btn-back btn-tranparent d-flex justify-content-center align-items-center border-0 rounded-circle"
              >
                <i className="bx bx-arrow-back bx-sm"></i>
              </button>
              <h4 className="page-title">{attributeDetails?.name}</h4>
            </div>
            <div className="row">
              <div className="col-lg-6">
                <h5 className="page-sub-title">{t("common.label.projects")}</h5>
                <h6 className="content-text">
                  {attributeDetails?.project?.name}
                </h6>
              </div>
              <div className="col-lg-6">
                <h5 className="page-sub-title">{t("common.label.stages")}</h5>
                <h6 className="content-text">
                  {attributeDetails?.stages &&
                    convertLinkObjectListToJoin(attributeDetails?.stages)}
                </h6>
              </div>
            </div>
            <hr className="border border-top-0" />
            <div className="table-container mb-4">
              <h5 className="page-sub-title">{t("common.button.actions")}</h5>
              {attributeDetails?.buttons &&
                attributeDetails?.buttons?.length > 0 && (
                  <table className="table table-bordered">
                    <thead className="table-light">
                      <tr>
                        <th>{t("common.label.actionName")}</th>
                        <th>{t("common.label.accessOnOff")}</th>
                        <th>{t("common.label.backgroundColor")}</th>
                        <th>{t("common.label.action")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {attributeDetails?.buttons.map((button) => (
                        <tr key={button.gid}>
                          <td>{button.name}</td>
                          <td>
                            <div className="form-check form-switch success-switch">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                attribute="switch"
                                id="flexSwitchCheckChecked"
                                name="accessButton"
                                checked={button.show}
                                onChange={(e) =>
                                  onSaveAction(button, e.target.checked)
                                }
                              />
                            </div>
                          </td>
                          <td>
                            <ul className="color-list">
                              {COLOR_SETTINGS.map((color) => (
                                <li className="round disabled" key={color}>
                                  <input
                                    type="radio"
                                    name={`backgroundColor${attributeId}${button.gid}${color}`}
                                    id={`backgroundColor${attributeId}${button.gid}${color}`}
                                    value={color}
                                    checked={button.backgroundColor === color}
                                    readOnly
                                  />
                                  <label
                                    htmlFor={`backgroundColor${attributeId}${button.gid}${color}`}
                                    style={{
                                      backgroundColor: color,
                                      borderColor: color,
                                    }}
                                  ></label>
                                </li>
                              ))}
                            </ul>
                          </td>
                          <td>
                            <ul className="color-list">
                              {COLOR_SETTINGS.map((color) => (
                                <li className="round disabled" key={color}>
                                  <input
                                    type="radio"
                                    name={`fontColor${attributeId}${button.gid}${color}`}
                                    value={color}
                                    id={`fontColor${attributeId}${button.gid}${color}`}
                                    checked={button.fontColor === color}
                                    readOnly
                                  />
                                  <label
                                    htmlFor={`fontColor${attributeId}${button.gid}${color}`}
                                    style={{
                                      backgroundColor: color,
                                      borderColor: color,
                                    }}
                                  ></label>
                                </li>
                              ))}
                            </ul>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
            </div>
            <hr className="border border-top-0" />
            <div className="table-container">
              <h5 className="page-sub-title">{t("common.button.fields")}</h5>
              <div className="table-container project-table-height">
                {attributeDetails?.fieldsetting &&
                  attributeDetails?.fieldsetting?.length > 0 && (
                    <table className="table table-bordered">
                      <thead className="table-light">
                        <tr>
                          <th>{t("common.label.field")}</th>
                          <th>{t("common.label.label")}</th>
                          <th>{t("common.label.canEdit")}</th>
                          <th>{t("common.label.showHide")}</th>
                          <th>{t("common.label.fieldType")}</th>
                          <th>{t("common.label.designType")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {attributeDetails?.fieldsetting.map((field) => (
                          <tr key={field.questionId}>
                            <td width={200}>
                              <div className="text-wrap">
                                {field.questionName}
                              </div>
                            </td>
                            <td width={200}>
                              <div className="text-wrap">{field.label}</div>
                            </td>
                            <td>
                              <div className="form-check form-switch success-switch">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  attribute="switch"
                                  id="flexSwitchCheckChecked"
                                  checked={field.edit}
                                  onChange={(e) =>
                                    onSaveField(
                                      field,
                                      e.target.checked,
                                      field.show
                                    )
                                  }
                                />
                              </div>
                            </td>
                            <td>
                              <div className="form-check form-switch success-switch">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  attribute="switch"
                                  id="flexSwitchCheckChecked"
                                  checked={field.show}
                                  onChange={(e) =>
                                    onSaveField(
                                      field,
                                      field.edit,
                                      e.target.checked
                                    )
                                  }
                                />
                              </div>
                            </td>
                            <td>
                              <select
                                className="form-select form-select-sm"
                                aria-label="Default select example"
                                value={field.fieldType || ""}
                                disabled
                              >
                                <option>- Select -</option>
                                {FEILD_TYPE_LIST.map((fType) => (
                                  <option value={fType.key} key={fType.key}>
                                    {fType.name}
                                  </option>
                                ))}
                              </select>
                            </td>
                            <td>
                              <select
                                className="form-select form-select-sm"
                                aria-label="Default select example"
                                value={field.designType || ""}
                                disabled
                              >
                                <option>- Select -</option>
                                {DESIGN_TYPE_LIST.map((dType) => (
                                  <option value={dType.key} key={dType.key}>
                                    {dType.name}
                                  </option>
                                ))}
                              </select>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
              </div>
            </div>
          </div>
        </main>
      </LoadingComponent>
    </>
  );
};
